export const statusMapping = {
  PENDING: "Pending",
  DRIVER_ASSIGNED: "Driver Assigned",
  DRIVER_APPROACHING: "Driver Approaching",
  DRIVER_ARRIVED: "Driver Arrived",
  PICKED_UP: "Picked Up",
  DRIVER_DEPARTED: "Driver Departed",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
  CANCELLED_BY_OUTLET: "Cancelled by Outlet",
  CANCELLED_BY_DRIVER: "Cancelled by Driver",
  CANCELLED_BY_ADMIN: "Cancelled by Admin",
  ARRIVED_AT_LOCATION: "Arrived at Location",
  NOBODY_ACCEPTED: "Not Accepted",
};

export const ORDER_STATUS = Object.freeze({
  PENDING: "Pending",
  DRIVER_ASSIGNED: "Driver-Assigned",
  DRIVER_APPROACHING: "Driver-Approaching",
  DRIVER_ARRIVED: "Driver-Arrived",
  PICKED_UP: "Picked-Up",
  DRIVER_DEPARTED: "Driver-Departed",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
  CANCELLED_BY_OUTLET: "Cancelled-By-Outlet",
  CANCELLED_BY_DRIVER: "Cancelled-By-Driver",
  CANCELLED_BY_ADMIN: "Cancelled-By-Admin",
  ARRIVED_AT_LOCATION: "Arrived-At-Location",
  NOBODY_ACCEPTED: "Nobody-Accepted",
});

export const statusCategories = {
  Pending: [
    "Pending",
    "Cancelled",
    "Cancelled-By-Outlet",
    "Cancelled-By-Driver",
    "Cancelled-By-Admin",
    "Nobody-Accepted",
  ],
  Delivering: [
    "Driver-Assigned",
    "Driver-Approaching",
    "Driver-Arrived",
    "Picked-Up",
    "Driver-Departed",
  ],
  Done: ["Delivered"],
};
